module.exports = __webpack_public_path__ + "img/ico_down.215904d1.svg";